import type { AvailableStrikeModeFieldBase } from 'models/forms/fields/AvailableStrikeModeFieldBase';
import { FieldMetadataBase } from 'models/forms/fields/FieldMetadataBase';
import { UnderlyingsFieldBase } from 'models/forms/fields/UnderlyingsField';
import type { Underlying } from 'models/underlying';

export const DEFAULT_STRIKE_METADATA: StrikeMetadata = { showMode: true, showDate: true, showSpot: true };
export interface StrikeMetadata {
  showSpot: boolean;
  showDate: boolean;
  showMode: boolean;
}

export type SingleUnderlyingSearchEditableFieldData = Underlying | Underlying[];

export type SingleUnderlyingSearchEditableFieldMetadata = UnderlyingsFieldBase &
  AvailableStrikeModeFieldBase &
  FieldMetadataBase<'SingleSearchEditableField', SingleUnderlyingSearchEditableFieldData> & {
    strike?: StrikeMetadata;
  };

export type SingleUnderlyingFieldMetadata = UnderlyingsFieldBase &
  AvailableStrikeModeFieldBase &
  FieldMetadataBase<'SingleUnderlyingField', SingleUnderlyingSearchEditableFieldData> & {
    strike?: StrikeMetadata;
  };
